export default __webpack_public_path__ + "static/media/ofb.d6ee958d.jpg";